export default "__VITE_ASSET__DgRIh7Nn__"